import { CIMSModule, CIMSPage, Permission } from '@cims-online/shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useDS() {
  return useProtectedMenuItem({
    module: CIMSModule.DS,
    pages: [
      {
        page: CIMSPage.DSLog,
        permission: Permission.ViewDesignSubmittal,
      },
      {
        page: CIMSPage.DSDisciplines,
        permission: Permission.ViewDesignSubmittalDiscipline,
      },
      {
        page: CIMSPage.DSTypes,
        permission: Permission.ViewDesignSubmittalType,
      },
      {
        page: CIMSPage.DSOrganizations,
        permission: Permission.ViewDesignSubmittalOrganization,
      },
      {
        page: CIMSPage.DSActions,
        permission: Permission.ViewDesignSubmittalAction,
      },
      {
        page: CIMSPage.DSQuickLinks,
        permission: Permission.ViewDesignSubmittalQuickLink,
      },
      {
        page: CIMSPage.DSNotifications,
        permission: Permission.ViewDSNotification,
      },
    ],
  })
}
